import React, { type ReactElement } from 'react';

import classnames from 'classnames';

import { DROPSECTION } from '../../../dataTestIds';
import { Icon, type IconName } from '../Icon';
import { H4, Text } from '../Typography';

import styles from './DropSection.module.scss';

export type DropSectionProps = {
    className?: string;
    disabled?: boolean;
    disabledText?: string;
    dragover?: boolean;
    icon?: IconName;
    subtitle?: string;
    title?: string;
    onClick?: () => void;
    children?: ReactElement | string;
};

export const DropSection = ({
    className,
    disabled,
    disabledText,
    dragover,
    icon = 's-icon-cloud-up',
    subtitle,
    title,
    onClick,
    children
}: DropSectionProps): ReactElement => {
    return (
        <div
            className={classnames(styles.dragdrop, className, {
                [styles.active]: dragover && !disabled,
                [styles.disabled]: disabled
            })}
            onClick={onClick}
            data-testid={DROPSECTION}
        >
            <span className={styles.icon}>
                <Icon name={icon} />
            </span>
            <H4 className={styles.mainText}>{title}</H4>
            <Text className={styles.descriptionText}>{subtitle}</Text>
            {children}
            {disabled && (
                <div className={styles.disabledView}>
                    <div className={styles.disabledText}>{disabledText}</div>
                </div>
            )}
        </div>
    );
};
